import React from 'react';
import './Logo.css';


function Logo() {
  return (
    <div className="logo-container">
      <div className="mabe"><img src="/images/logo_build_mabe.png" alt="Logo Mabe" width="100%" /></div>
      <div className="capacita">Capacita</div>
    </div>
  );
}

export default Logo;
